import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface VendorContextType {
  vendor: any;
  role: string;
  branch: any;
  token: string;
  setVendorDetails: (data: VendorContextType) => void;
  logout: () => void;
  loading: boolean;
}

const VendorContext = createContext<VendorContextType | undefined>(undefined);

export const VendorProvider = ({ children }: { children: ReactNode }) => {
  const [vendor, setVendor] = useState<any>(null);
  const [role, setRole] = useState<string>('');
  const [branch, setBranch] = useState<any>(null);
  const [token, setToken] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  const setVendorDetails = (data: VendorContextType) => {
    setVendor(data.vendor);
    setRole(data.role);
    setBranch(data.branch);
    setToken(data.token);
    localStorage.setItem('jwtToken', data.token);
    localStorage.setItem('vendor', JSON.stringify(data.vendor));
    localStorage.setItem('role', data.role);
    localStorage.setItem('branch', JSON.stringify(data.branch));
  };

  const logout = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('vendor');
    localStorage.removeItem('role');
    localStorage.removeItem('branch');
    setVendor(null);
    setRole('');
    setBranch(null);
    setToken('');
  };

  useEffect(() => {
    const storedToken = localStorage.getItem('jwtToken');
    const storedVendor = localStorage.getItem('vendor');
    const storedRole = localStorage.getItem('role');
    const storedBranch = localStorage.getItem('branch');

    if (storedToken && storedVendor) {
      setToken(storedToken);
      setVendor(JSON.parse(storedVendor));
      setRole(storedRole || '');
      setBranch(storedBranch ? JSON.parse(storedBranch) : null);
    }
    setLoading(false); // <--- mark loading complete
  }, []);

  return (
    <VendorContext.Provider
      value={{ vendor, role, branch, token, setVendorDetails, logout, loading }}
    >
      {children}
    </VendorContext.Provider>
  );
};


export const useVendorContext = (): VendorContextType => {
  const context = useContext(VendorContext);
  if (!context) {
    throw new Error('useVendorContext must be used within a VendorProvider');
  }
  return context;
};
